import React, { useState, Component, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "../../Navbar/Components/Navbar.css";
import "../../assets/LOGO.png";
import { Image, NavItem } from "react-bootstrap";
import { BsSearch } from "react-icons/bs";
import { BiSearch, BiUser, BiUserCircle } from "react-icons/bi";
import { AiOutlineHeart } from "react-icons/ai";
import { FiShoppingCart } from "react-icons/fi";

import {
  BrowserRouter as Route,
  Router,
  Link,
  Switch,
  useLocation,
} from "react-router-dom";

export const Topnav = () => {
  const [isNavLink, setIsNavLink] = useState("Categories");

  return (
    <>
      <Navbar id="botone" expand="lg">
        <Navbar.Brand>
          <Link to="/">
            <Image src={require("../../assets/Logomain.png")} />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="ml-auto my-2" navbarScroll>
            <Link to="/AirportService" className="nav-link">
              Airport Services
            </Link>
            <Link to="/RentACar" className="nav-link">
              Rent A Car
            </Link>
            <Link to="/MainTravel" className="nav-link">
              Travel & Tour
            </Link>
            <Form className="d-flex">
              <fieldset>
                <Form.Control
                  type="search"
                  placeholder="Search"
                  className="me-2 bg-black border-white"
                  aria-label="Search"
                />
              </fieldset>
              {/* <Button variant="outline-success">Search</Button> */}
            </Form>
            <Link to="/Signup" className="nav-link">
              <button className="btnsignup">Signup</button>
            </Link>
            <Link to="/Login" className="nav-link">
              <button className="btnlogin gap-2 d-flex align-items-center">
                <BiUserCircle size={25} />
                Login
              </button>
            </Link>
            {/* <Link to="/Login" className="nav-link">
              <Button className="btn-login w-full">Login</Button>
            </Link>

            <Link to="/Signup" className="nav-link">
              <Button className="btn-signup w-full">Sign up</Button>
            </Link> */}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};
